import i18next from "i18next";
import english from "./interface.en.json" with { type: "json" };

export type InterfaceMessage = keyof typeof english;

/** Labels are evaluated at display time; payload values and identifiers stay unchanged. */
export function msg(key: InterfaceMessage, values?: Record<string, unknown>): string {
	return i18next.t(`interface.${key}`, { defaultValue: english[key], ...values }) as string || english[key];
}
